/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormOnEditUsers from "./FormOnEditUsers";
import FormOnUsers from "./FormOnUsers";
import OptionHandle from "./OptionHandle";
import TableOnUsers from "./TableOnUsers";

const UserstoRole = () => {
	const BaseUrl = `${url.roleUsers}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDataTables,
		addData,
		updateData,
		deleteData,
		refreshData,
		tableRef,
		MultipleHandleOptions,
		stateOption,
		setStateOption,
	} = fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const [optionChange, setOptionChange] = useState({
		idlayanan: "0",
		idrole: "0",
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
		setStateOption({ ...stateOption, optionResult: null });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		setData(params);
		params &&
			stateOption &&
			stateOption.option1.map((row) => {
				stateOption.option2.map((rows) => {
					if (params.role === rows.nama && params.layanan === row.nama)
						setData({ ...params, idlayanan: row.id, idrole: rows.id });
					return rows;
				});
				return row;
			});
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/add_user`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_user?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);
		if (action === "delete")
			result = await deleteData(
				`${BaseUrl}/delete_user?id=${data.id}`,
				data.nama_user,
				data
			);
		return result;
	};

	return (
		<Grid direction="column" alignItems="center">
			<OptionHandle
				stateOption={stateOption}
				data={data}
				state={optionChange}
				setState={setOptionChange}
				handleSearch={refreshData}
			/>
			<TableOnUsers
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				fetchAPI={fetchAPI}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
				state={optionChange}
			/>
			<FormOnUsers
				stateOption={stateOption}
				MultipleHandleOptions={MultipleHandleOptions}
				open={openAdd}
				fetchAPI={fetchAPI}
				handleClose={handleOpenCloseFormAdd}
			/>
			<FormOnEditUsers
				fetchAPI={fetchAPI}
				stateOption={stateOption}
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
			/>
		</Grid>
	);
};
export default UserstoRole;
